// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__L68HF","tab":"ProcedureTabs_tab__gBsI9"};